import React from 'react';

const SvgPagination = (props) => (
    <svg width={7} height={8} {...props} viewBox="0 0 7 8">
        <path d="M0 0v8l7-4z" fill={props.color || '#FFF'} fillRule="evenodd" />
    </svg>
);

export default SvgPagination;
